import { render, staticRenderFns } from "./ProductReport.vue?vue&type=template&id=023797db&scoped=true"
import script from "./ProductReport.vue?vue&type=script&lang=js"
export * from "./ProductReport.vue?vue&type=script&lang=js"
import style0 from "./ProductReport.vue?vue&type=style&index=0&id=023797db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023797db",
  null
  
)

export default component.exports